import { Expose, Type } from "class-transformer";
import { CertificationValuationAccountingCategoryEnum } from "@altertec_gparn/lib";

export class UpdateCertificationValuationAccountingConfigurationLineDto {
  @Expose()
  category: CertificationValuationAccountingCategoryEnum;

  @Expose()
  accountingAccountId?: string | null;
}

export class UpdateCertificationValuationAccountingConfigurationDto {
  @Expose()
  @Type(() => UpdateCertificationValuationAccountingConfigurationLineDto)
  config: UpdateCertificationValuationAccountingConfigurationLineDto[];
}
